import React from 'react';

const WhyHireMe = () => {
    return (
        <div className='container'>
            <div className='mt-5'>
                <hr />
                <h3 className='text-center my-4'>My Specialties</h3>
                <h2 className='text-center'>Why Choose <span className='text-danger'>Me</span> </h2>
                <p className='mt-3'>A tourist or travel guide requires very strong communication and public speaking skills to convey information effectively. He needs Knowledge of the Tour Area, easy to communicate, an engaging storyteller and a decent personality. But most importantly he have need active listening skills to ensure tourists get your full attention. This skill also helps you understand any questions you receive during a tour.</p>
                <p><strong>❝Over the years, I have been guiding tourists and gaining experience, which has enabled me to guide you in the right direction. I have also worked tirelessly on my communication skills and teamwork skills, which I can help you in any unexpected environment, if you take my service I will try my best to give you.❞</strong></p>
            </div>
        </div>
    );
};

export default WhyHireMe;